import React, {Component} from "react";
import {Translate} from "react-i18nify";

import * as translationHelper from "../../../helpers/translationHelper";

export default class InvalidDatabasesPanel extends Component {
    getDbStatus = (key, db) => {
        return (
            <tr key={key} className="server-row blue">
                <td>
                    <div>{db.name}</div>
                </td>
                <td>
                    <div>{translationHelper.getDbStatusTranslation(db.status)}</div>
                </td>
            </tr>
        );
    };

    getDatabaseStatuses = () => {
        let statusList = [];
        let key = 0;

        for (let db of this.props.invalidDatabaseList) {
            if (db !== null) {
                statusList.push(this.getDbStatus(key, db));
                key++;
            }
        }

        return statusList;
    };

    getContent = () => {
        return (
            <div className="slim-scroll col-xs-12 server-table">
                <table>
                    <thead>
                        <tr>
                            <th className="color-primary">
                                <Translate value="general.database" />
                            </th>
                            <th className="color-primary">
                                <Translate value="general.note" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>{this.getDatabaseStatuses()}</tbody>
                </table>
            </div>
        );
    };

    render() {
        return (
            <React.Fragment>
                <div className="col-xs-12 select-server-text">
                    <Translate value="welcome.availableDatabase" />
                </div>
                {this.getContent()}
            </React.Fragment>
        );
    }
}
